/**
 * Describes the edges > nodes structure of Gatsby GraphQL query results to
 * simplifiying props definitions. T is the queried object.
 *
 * This lets us simplify:
 *
 *   data: {
 *     recipies: edges Array<{
 *       node: {
 *         name: string
 *       }
 *     }>
 *   }
 *
 * to:
 *
 *   data: {
 *     recipies: QueryResult<{
 *       name: string
 *     }>
 *   }
 *
 */
export type QueryResult<T> = {
  edges: Array<{
    node: T;
  }>;
};

/**
 * Unwrap results from a Gatsby GraphQL query from the given edges > nodes
 * structure which isn't necessary for simple queries. Returns a flat array of
 * requested objects.
 */
export function unwrapNodes<T>(result: QueryResult<T> | null): Array<T> {
  // If a query returns no results, Gatsby doesn't return a key for that value
  // at all. I think an empty array for an empty result makes a lot more sense,
  // so lets allow this function to quitely handle that.
  if (result == null) {
    return [];
  }
  return result.edges.map((e) => e.node);
}
